import { z } from 'zod';
import { ImageObjectSchema } from '../components/Image';

const StructuredData = z.record(z.string(), z.any());

export const SEOSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  image: ImageObjectSchema.nullable().optional(),
  structuredData: StructuredData.optional()
});

export type SanityStructuredData = z.infer<typeof StructuredData>;
export type SEOAttributes = z.infer<typeof SEOSchema>;
